import { z } from "zod";

export const envSchema = z.object({
	VITE_APP_NAME: z.string(),
	VITE_APP_SLUG: z.string(),
	VITE_SERVER_URL: z.url(),
	VITE_GOOGLE_CLIENT_ID: z.string().optional(),
	VITE_MICROSOFT_CLIENT_ID: z.string().optional(),
	VITE_SENTRY_DSN: z.string().optional(),
	VITE_PUBLIC_POSTHOG_TOKEN: z.string().optional(),
	VITE_PUBLIC_POSTHOG_HOST: z.string().optional(),
	VITE_COMETCHAT_APP_ID: z.string().min(1),
	VITE_COMETCHAT_REGION: z.string().min(1),
});

const _env = envSchema.parse(import.meta.env);

export const env = {
	MODE: import.meta.env.MODE,
	APP_NAME: _env.VITE_APP_NAME,
	APP_SLUG: _env.VITE_APP_SLUG,
	SERVER_URL: _env.VITE_SERVER_URL,
	GOOGLE_CLIENT_ID: _env.VITE_GOOGLE_CLIENT_ID,
	MICROSOFT_CLIENT_ID: _env.VITE_MICROSOFT_CLIENT_ID,
	SENTRY_DSN: _env.VITE_SENTRY_DSN,
	POSTHOG_TOKEN: _env.VITE_PUBLIC_POSTHOG_TOKEN,
	POSTHOG_HOST: _env.VITE_PUBLIC_POSTHOG_HOST,
	COMETCHAT_APP_ID: _env.VITE_COMETCHAT_APP_ID,
	COMETCHAT_REGION: _env.VITE_COMETCHAT_REGION,
} as const;
